<div
    *ngIf="value"
    class="agpr-subject-chips"
    [class.agpr-subject-chips--hasChips]="value.length > 0"
>
    <div class="agpr-inputGroupRow">
        <agpr-grouped-autocomplete
            #autocomplete
            class="agpr-subject-chips-autocomplete"
            [id]="id + '.autocomplete'"
            labelField="name"
            [placeholder]="placeholder | localize"
            [clearOnBlur]="true"
            [showEmptyMessage]="true"
            [suggestionsFetcher]="journodexSubjectsService.quicksearch.bind(journodexSubjectsService, value)"
            optionGroupChildren="children"
            [groupTemplate]="groupTemplate"
            [itemsListTemplate]="itemsListTemplate"
            [overlayTemplate]="overlayTemplate"
            [footerTemplate]="footerTemplate"
            [forceClearAfterSelection]="true"
            (itemSelected)="addChip($event)"
            (viewAllInGroup)="autocompleteBrowseAllClicked.emit({ parent: $event })"
            [ariaLabelledBy]="ariaLabelledBy"
            [ariaDescribedBy]="id + '_values'"
        ></agpr-grouped-autocomplete>
        <agpr-button
            [style]="buttonTypes.block"
            class="agpr-subject-chips-manageButton"
            icon="fa-regular fa-duotone fa-binoculars"
            tooltip="Monitoring.search.browseAll"
            tooltipPosition="top"
            (click)="browseAll.emit($event)"
            [ariaLabel]="'Monitoring.search.browseAll'"
        ></agpr-button>
    </div>
    <div
        #chipList
        *ngIf="value.length > 0"
        class="agpr-subject-chips-chipArea"
        role="group"
        [attr.aria-labelledby]="ariaLabelledBy"
    >
        <div
            class="agpr-subject-chips-subjectRow"
            *ngFor="let topSubject of subjectTree; index as j"
        >
            <div class="agpr-subject-chips-subjectRow-headerContainer">
                <span [id]="id + '_subjectRow_' + j + '_label'" class="agpr-subject-chips-subjectRow-parent">{{ topSubject.name }}</span>
                <div class="agpr-subject-chips-subjectRow-trash-container">
                    <agpr-button
                        [id]="id + '_subjectRow_' + j + '_delete'"
                        [style]="buttonTypes.icon"
                        icon="fa-kit-duotone fa-agpr-remove-all"
                        (click)="removeParentSubject(topSubject)"
                        class="agpr-subject-chips-subjectRow-trash"
                        tooltip="Discover.dialogs.browsers.subject.delete"
                        [ariaLabel]="('Discover.dialogs.browsers.subject.delete' | localize) + ' in category ' + topSubject.name"
                    ></agpr-button>
                </div>
            </div>

            <span
                *ngIf="topSubject.children.length > 0"
            >
                <agpr-chips
                    [id]="id + '_subjectRow_' + j + '_chips'"
                    [(ngModel)]="topSubject.children"
                    [ignorePadding]="true"
                    (ngModelChange)="updateSubjectTree(true)"
                    labelFieldName="name"
                    [ariaLabelledBy]="id + '_subjectRow_' + j + '_label'"
                    [handleFocus]="false"
                    (chipRemoved)="handleChipFocus($event, j)"
                    (allChipsRemoved)="handleChipFocus(0, j)"
                    [clearAllChipsButton]="false"
                ></agpr-chips>
            </span>
        </div>
    </div>
    <div
        [id]="id + '_values'"
        class="u-srOnly"
    >
        <ul
            *ngFor="let topSubject of subjectTree"
            role="group"
        >
            {{ topSubject.name | localize }} Subject Group
            <li *ngFor="let subject of topSubject.children">
                {{ subject.name | localize }}
            </li>
        </ul>
    </div>
</div>
<!-- eslint-disable @angular-eslint/template/role-has-required-aria, @angular-eslint/template/interactive-supports-focus -->
<!-- Grouped Autocomplete Templates -->
<ng-template #overlayTemplate let-suggestions="suggestions">
    <li
        *ngIf="!suggestions || suggestions.length === 0"
        role="option"
    >
        <agpr-message
            class="agpr-subject-chips-noContent"
            [severity]="messageSeverityEnum.noContent"
        >
            <span>
                {{ 'Discover.dialogs.browsers.subject.noResults' | localize }}
            </span>
        </agpr-message>
    </li>
</ng-template>

<ng-template #groupTemplate let-group pTemplate="group" let-index="groupIdx">
    <div class="agpr-subject-chips-group">
        <span class="agpr-subject-chips-group-name">
            {{ group.name }}
        </span>
        <agpr-button
            [style]="buttonTypes.block"
            class="agpr-chips-manageButton"
            icon="fa-regular fa-duotone fa-binoculars"
            [tooltip]="'Discover.dialogs.browseAll.subSubjects' | localize : { subject: group.name }"
            (click)="autocompleteBrowseAllClicked.emit({ parent: group })"
        ></agpr-button>
    </div>
</ng-template>

<ng-template #itemsListTemplate
    let-suggestionsToDisplay
    let-itemSelectedFn="selectItem"
    let-index="groupIdx"
    let-group="group"
>
    <ng-container
        *ngFor="let option of group.children | slice:0:5; let idx = index;"
    >
        <li
            role="option"
            class="agpr-subject-chips-listItemContainer"
            [id]="option.id"
            (click)="itemSelectedFn(option)"
        >
            <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option, index: idx}"></ng-container>
        </li>
    </ng-container>
</ng-template>

<ng-template #itemTemplate let-item>
    <div class="agpr-subject-chips-listItem">
        <span> {{ item.name }} </span>
    </div>
</ng-template>

<ng-template #footerTemplate let-value>
    <div class="agpr-subject-chips-footer">
        <agpr-button
            id="checkBoxFilter.toggleButton"
            [style]="buttonTypes.link"
            [label]="'Discover.dialogs.browseAll.viewSubjectsRelatedTo' | localize: { subject: value }"
            (click)="autocompleteBrowseAllClicked.emit({ query: value })"
        ></agpr-button>
    </div>
</ng-template>
<!-- eslint-enable @angular-eslint/template/role-has-required-aria, @angular-eslint/template/interactive-supports-focus -->
